import { DashboardAction, DashboardActionTypes } from './actions';
import {
  activeFleetFactory,
  AgreementsStatsFactory,
  DashboardStateFactory,
  revenueFactory,
  UtilizationDataFactory,
} from './factories';

const initialState = DashboardStateFactory();

function dashboardReducer(state = initialState, action: DashboardAction) {
  switch (action.type) {
    case DashboardActionTypes.ACTIVE_FLEET_START_LOADING:
      return state.setIn(['activeFleet', 'loading'], true);
    case DashboardActionTypes.REVENUE_START_LOADING:
      return state.setIn(['revenue', 'loading'], true);
    case DashboardActionTypes.AGREEMENTS_STATS_START_LOADING:
      return state.setIn(['agreements', 'loading'], true);
    case DashboardActionTypes.UTILIZATION_DATA_START_LOADING:
      return state.setIn(['utilization', 'loading'], true);
    case DashboardActionTypes.GET_ACTIVE_FLEET_SUCCESS:
      return state.set('activeFleet', activeFleetFactory({ loading: false, values: action.payload.activeFleet }));
    case DashboardActionTypes.GET_REVENUE_SUCCESS:
      return state.set('revenue', revenueFactory({ loading: false, values: action.payload.revenue }));
    case DashboardActionTypes.GET_AGREEMENTS_STATS_SUCCESS: {
      // TODO: Remove this legacy support after backend is updated
      const agreementsPayload = action.payload.agreements;
      // @ts-expect-error TS(2339): Property 'openedAgreementsByDay' does not exist on type 'OpenedAgreementsStats'.
      if (agreementsPayload.openedAgreementsByDay) {
        // @ts-expect-error TS(2339): Property 'openedAgreementsByDay' does not exist on type 'OpenedAgreementsStats'.
        const { openedAgreementsByDay, ...rest } = agreementsPayload;
        const updated = {
          ...rest,
          openedAgreements: openedAgreementsByDay,
        };
        return state.set('agreements', AgreementsStatsFactory({ loading: false, values: updated }));
      }

      return state.set('agreements', AgreementsStatsFactory({ loading: false, values: agreementsPayload }));
    }
    case DashboardActionTypes.GET_UTILIZATION_DATA_SUCCESS:
      return state.set('utilization', UtilizationDataFactory({ loading: false, values: action.payload.utilization }));
    case DashboardActionTypes.GET_ACTIVE_FLEET_FAIL:
      return state.setIn(['activeFleet', 'loading'], false);
    case DashboardActionTypes.GET_REVENUE_FAIL:
      return state.setIn(['revenue', 'loading'], false);
    case DashboardActionTypes.GET_AGREEMENTS_STATS_FAIL:
      return state.setIn(['agreements', 'loading'], false);
    case DashboardActionTypes.GET_UTILIZATION_DATA_FAIL:
      return state.setIn(['utilization', 'loading'], false);
    default:
      return state;
  }
}

export default dashboardReducer;
